module.exports = __webpack_public_path__ + "static/media/Daniel_Koepplin.358ac534.jpeg";